import { computed, Injectable, Signal, signal } from '@angular/core';

/**
 * Service for storing a given claim number.
 *
 * @author Jesse Bloomster
 */
@Injectable({
	providedIn: 'root'
})
export class ClaimNumberService {
	private claimNumberSig = signal<string | null>(null);

	/**
	 * Get the claim number.
	 */
	getClaimNumber(): Signal<string | null> {
		return computed(this.claimNumberSig);
	}

	/**
	 * Update the claim number with the given value.
	 *
	 * @param claimNumber the value for the claim number
	 */
	updateClaimNumber(claimNumber: string | null) {
		this.claimNumberSig.set(claimNumber);
	}
}
